// La etiqueta "Borrador" al lado del 480p Profesional, con la explicación al hover
// (ADR-2026-09-27-borrador-480p-y-pasar-a-1080p). Quien la monta decide si corresponde
// (`esBorrador(calidad, '480p')`): el componente sólo dibuja.
import React from 'react';
import { AYUDA_BORRADOR, ETIQUETA_BORRADOR } from '../lib/resolucionVideo';

export const EtiquetaBorrador: React.FC<{ compacta?: boolean; className?: string }> = ({
  compacta = false,
  className = '',
}) => (
  <span
    title={AYUDA_BORRADOR}
    aria-label={`${ETIQUETA_BORRADOR}: ${AYUDA_BORRADOR}`}
    className={`inline-flex items-center rounded-full bg-black/[0.06] font-semibold text-brand-black/70 ${
      compacta ? 'px-1.5 py-px text-[10px]' : 'px-2 py-0.5 text-[11px]'
    } ${className}`}
  >
    {ETIQUETA_BORRADOR}
  </span>
);

export default EtiquetaBorrador;
